// src/reducers/userReducer.js
import {
    GET_REVIEW_SUCCESS,
    GET_REVIEW_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const reviewReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_REVIEW_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_REVIEW_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  